import type { FaireProductEntity } from "../../entity_types/product";

export const p_uqv5wcu7wf: FaireProductEntity = {
  token: "p_uqv5wcu7wf",
  type: "product",
  name: "Rainbow Sun Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/78010f17d7109bf58bf8c619f7c7e435cb009442d3662b9108ef6bd517639b62.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bf25a14397780858fb40b6a17c29dc8a61a1c088f539fa30646c9a6cc081af69.jpeg",
    "https://cdn.faire.com/fastly/6779aa1002465f828307ea62bcdfcd62fa89bcb2b2b6d481567a63213d28c4ef.png",
    "https://cdn.faire.com/fastly/9e277dedec82757ba6fd9f5cbf40b12708297ea3174bc9bf823a0827e72346c3.png",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a reminder that someone is seen. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:37.477Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
